module.exports = __webpack_public_path__ + "static/media/android_logo.8ba6d9c2.png";